module.exports = __webpack_public_path__ + "static/media/bag-check.26997121.svg";